import conf from '~/app/conf'
import { IAxiosClientError } from '~/app/react-query/axios'
import { getYaNative } from '@yanolja-org/ya-native'
import { isNative } from '~/app/utils/typeguards'

/**
 * @summary 국내주문 공통 Axios 에러 핸들러
 * @param error - IAxiosClientError
 */
const domesticErrorHandler = (error: IAxiosClientError) => {
  const { status, data } = error.response
  if (status === 401) {
    // 기본 값: 로그인 페이지로 이동
    const { isMemberOrder } = data.data ?? { isMemberOrder: true }

    const redirectUrl = encodeURIComponent(
      `${window.location.origin}${window.location.pathname}${window.location.search}`
    )
    if (isMemberOrder) {
      const yaNative = getYaNative()
      if (isNative(yaNative)) {
        yaNative.login()
      }
      window.location.replace(`${conf.web.url}/login?redirect=${redirectUrl}`)
    } else {
      window.location.replace(`${conf.web.url}/visitorlogin?type=platformOrder`)
    }
    return
  }
}

export default domesticErrorHandler
